module.exports = __webpack_public_path__ + "media/images/countryrect/nu-245cb1a3ea4e2c57e865baffbdf99c3e.svg";